<template>
  <div>
    <div v-if="activeAccount" id="app">
      <NavBar v-if="!$route.meta.hideNav != serviceUnavailable" />
      <Announcement />
      <CardUpdateNeeded />
      <ServiceUnavailable v-if="serviceUnavailable" />
      <keep-alive :exclude="excludeFromKeepAlive">
        <router-view v-if="login_check" class="mt-4" />
      </keep-alive>
      <div v-if="!login_check && auth_initialized && !authorized">
        <b-container>
          <b-row>
            <b-col md="10" offset-md="1" class="mb-4">
              <p class="alert alert-info">
                This page requires an account. Please login or sign-up below.
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" offset-md="1">
              <h4>Login</h4>
              <Login />
            </b-col>
            <b-col md="1" class="right-border" />
            <b-col md="4" offset-md="1">
              <div v-if="show_creation_ui">
                <h4>Sign up below</h4>
                <CreateAccount />
              </div>
              <div v-else>
                <h4>New to Soundslides 3?</h4>
                <p>Create an account to get started.</p>
                <p>
                  <b-btn variant="primary" @click="show_creation_ui = true">
                    Create My Account
                  </b-btn>
                </p>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div v-if="!login_check && !auth_initialized && !authorized">
        <div class="d-flex justify-content-center mb-3 mt-5">
          <b-spinner label="Loading..." />
        </div>
      </div>
      <div v-if="authorized && !serviceUnavailable">
        <b-container>
          <b-row>
            <b-col>
              <UserPrefsBinder />
              <ShowsBinder />
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <div v-else>
      <!-- Closed account. -->
      <b-container>
        <b-row>
          <b-col md="6" offset="3" class="mt-5">
            <h1>
              This account is closed.
            </h1>
            <p class="mt-3">
              For security's sake, the data from your closed account will be
              permanently deleted after 30 days.
            </p>
            <p>
              If you need to get back into your account before then for any
              reason, shoot us an email. We can help!
            </p>
            <p>
              <b-btn @click="$store.dispatch('sign_out')">
                Return to front
              </b-btn>
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <footer class="container mt-5">
      <cookie-law theme="dark-lime" />
    </footer>
  </div>
</template>

<script>
import "@/fstore";
import CookieLaw from "vue-cookie-law";
import CreateAccount from "@/components/CreateAccount";
import ServiceUnavailable from "@/components/ServiceUnavailable";
import Announcement from "@/components/Announcement";
import CardUpdateNeeded from "@/components/CardUpdateNeeded";
import Login from "@/components/Login";
import NavBar from "@/components/NavBar.vue";
import ShowsBinder from "@/components/binders/ShowsBinder.vue";
import UserPrefsBinder from "@/components/binders/UserPrefsBinder.vue";
export default {
  name: "App",
  components: {
    Announcement,
    CardUpdateNeeded,
    CookieLaw,
    CreateAccount,
    Login,
    NavBar,
    ShowsBinder,
    UserPrefsBinder,
    ServiceUnavailable
  },
  data() {
    return {
      show_creation_ui: false,
      excludeFromKeepAlive: [
        "EditorImportUploader",
        "EditorLibrary",
        "EditorShowSettings",
        "EditorVideoExport",
        "Show",
        "ShowPlayer",
        "Upgrade",
        "UpgradePayPal",
        "ShowImport"
      ]
    };
  },
  computed: {
    activeAccount() {
      if (this.authorized) {
        return (this.$store.state.user_doc || {}).closed !== true;
      }
      return true;
    },
    authorized() {
      return this.$store.state.authorized;
    },
    serviceUnavailable() {
      return this.$store.state.serviceUnavailable;
    },
    auth_initialized() {
      return this.$store.state.auth_initialized;
    },
    login_check() {
      // Must pass all.
      if (this.$route.meta.login_required) {
        if (!this.authorized) {
          return false;
        }
      }
      // User doc requirements.
      if (this.$route.meta.require_user_doc_pref) {
        var item = this.$route.meta.require_user_doc_pref;
        console.log(item);
        if (this.$store.state.user_doc[item.flag_name] != item.value) {
          return false;
        }
      }
      // User requirements.
      if (this.$route.meta.require_user_pref) {
        var user_item = this.$route.meta.require_user_pref;
        console.log(user_item);
        if (this.$store.state.user[user_item.flag_name] != user_item.value) {
          return false;
        }
      }
      return true;
    }
  },
  //watch: {
  //  $route:{
  //    handler: (to) => {
  //      document.title = 'Goldilocks Forecast: ' + (to.meta.title || 'Welcome');
  //    },
  //    immediate: true
  //  }
  //},
  //created: function() {
  //  //this.load_song_data();
  //},
  //methods: {
  //
  //},
  mounted() {
    // Register this for toaster.
    this.$store.commit("set_component_instance", this);
  }
};
</script>

<style lang="scss">
.right-border {
  border-right: 1px solid #cfcfcf;
}
// Unscoped, .fa-icon adjustment for use in buttons.
.btn {
  & .fa-icon {
    position: relative;
    width: auto;
    height: 0.8em; /* or any other relative font sizes */

    /* You would have to include the following two lines to make this work in Safari */
    max-width: 100%;
    max-height: 100%;
    bottom: 0.1em;
  }
}
// Unscoped, .fa-icon adjustment for use everywhere else. Uses font size of enclosing tag.
.fa-icon {
  position: relative;
  width: auto;
  height: 1em; /* or any other relative font sizes */

  /* You would have to include the following two lines to make this work in Safari */
  max-width: 100%;
  max-height: 100%;
  bottom: 0.15em;
}
</style>
